import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { Check } from '@phosphor-icons/react';
import { forwardRef } from 'react';

import { cn } from '../../utils/cn';

export const Checkbox = forwardRef(function Checkbox(
  { className, invalid = false, ...props },
  ref,
) {
  return (
    <RadixCheckbox.Root
      ref={ref}
      aria-invalid={invalid || undefined}
      data-ds-id={props.checked ? 'ds/input/checkbox--checked' : 'ds/input/checkbox--default'}
      className={cn(
        'peer size-space-5 shrink-0 rounded-ds-sm border border-stone-300 dark:border-stone-600 bg-card transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-transparent data-[state=checked]:bg-gradient-to-br data-[state=checked]:from-sage-500 data-[state=checked]:to-sage-600 data-[state=checked]:shadow-[0_4px_12px] data-[state=checked]:shadow-sage-glow data-[state=checked]:text-white',
        invalid ? 'border-danger-500' : '',
        className,
      )}
      {...props}
    >
      <RadixCheckbox.Indicator className="flex items-center justify-center text-current">
        <Check className="h-4 w-4" />
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
});
